import React from 'react';

/**
 * Classical Torah scroll icon — two wooden atzei chaim handles flanking an
 * open parchment sheet with faint text lines. Universally recognized as
 * "the Torah" (rather than a dressed sefer Torah with mantle + crown).
 *
 * All strokes use `currentColor`; pair with `text-[#9a7b24]` for gold.
 */
const TorahIcon = React.forwardRef(function TorahIcon(
  { className = '', size = 24, ...rest },
  ref,
) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...rest}
    >
      {/* LEFT wooden roller (atzei chaim) */}
      <path
        d="M4 5.5 v13"
        strokeWidth="2"
      />
      <ellipse cx="4" cy="5.5" rx="1.3" ry="0.6" fill="currentColor" stroke="none" />
      <ellipse cx="4" cy="18.5" rx="1.3" ry="0.6" fill="currentColor" stroke="none" />
      <circle cx="4" cy="4.6" r="0.5" fill="currentColor" stroke="none" />
      <circle cx="4" cy="19.4" r="0.5" fill="currentColor" stroke="none" />

      {/* RIGHT wooden roller */}
      <path
        d="M20 5.5 v13"
        strokeWidth="2"
      />
      <ellipse cx="20" cy="5.5" rx="1.3" ry="0.6" fill="currentColor" stroke="none" />
      <ellipse cx="20" cy="18.5" rx="1.3" ry="0.6" fill="currentColor" stroke="none" />
      <circle cx="20" cy="4.6" r="0.5" fill="currentColor" stroke="none" />
      <circle cx="20" cy="19.4" r="0.5" fill="currentColor" stroke="none" />

      {/* Parchment sheet between the rollers, with gently curled edges */}
      <path
        d="M5.5 6.5 Q6.2 6 7 6.2 L17 6.2 Q17.8 6 18.5 6.5 L18.5 17.5 Q17.8 18 17 17.8 L7 17.8 Q6.2 18 5.5 17.5 Z"
        fill="currentColor"
        fillOpacity="0.14"
      />
      <path
        d="M5.5 6.5 Q6.2 6 7 6.2 L17 6.2 Q17.8 6 18.5 6.5 L18.5 17.5 Q17.8 18 17 17.8 L7 17.8 Q6.2 18 5.5 17.5 Z"
      />

      {/* Faint columns of text on the parchment */}
      <line x1="7.5" y1="9"  x2="11.2" y2="9" strokeOpacity="0.6" />
      <line x1="7.5" y1="11" x2="11.2" y2="11" strokeOpacity="0.6" />
      <line x1="7.5" y1="13" x2="11.2" y2="13" strokeOpacity="0.6" />
      <line x1="7.5" y1="15" x2="11.2" y2="15" strokeOpacity="0.6" />

      <line x1="12.8" y1="9"  x2="16.5" y2="9" strokeOpacity="0.6" />
      <line x1="12.8" y1="11" x2="16.5" y2="11" strokeOpacity="0.6" />
      <line x1="12.8" y1="13" x2="16.5" y2="13" strokeOpacity="0.6" />
      <line x1="12.8" y1="15" x2="16.5" y2="15" strokeOpacity="0.6" />
    </svg>
  );
});

export default TorahIcon;
